import { BaseWithId } from '@app/shared/models/base';

export interface CommentSummary {
    author: string;
    author_id: string;
    last_modification_date: Date;
    comment: string;
}

export interface Commentable extends CommentSummary {
    identifier: string;
}

export class SMPComment extends BaseWithId
                        implements Commentable {

    get identifier() {
        return this.id;
    }

    public client_id: string;
    public case_id: string;

    public author_id: string;
    public author: string;

    public last_modification_date: Date;
    public comment: string;

    constructor(json?: any) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            last_modification_date: json && json.last_modification_date ? new Date(json.last_modification_date) : null
        });
    }
}
